
export const getDynamicSelectedValues = () => {
    let selectElement = document.querySelector(".newValue");
    return selectElement ? selectElement.value : "";

};


export const setDynamicSelectedValues = (e) => {

    return e.target.value;
};